var map = {
	"./adjust_off.png": 556,
	"./book_off.png": 558,
	"./cancelUpload_off.png": 563,
	"./change_class_name_off.png": 565,
	"./check_off.png": 567,
	"./delete_off.png": 569,
	"./download_off.png": 572,
	"./excel_off.png": 574,
	"./icon_quiz_off.png": 605,
	"./icon_read_off.png": 607,
	"./icon_text_off.png": 612,
	"./icon_video_off.png": 615,
	"./lesson_score_off.png": 263,
	"./more_dots_off.png": 619,
	"./more_info_off.png": 621,
	"./play_sound_off.png": 623,
	"./record_off.png": 625,
	"./setting_off.png": 627,
	"./share_off.png": 629,
	"./single_add_off.png": 631,
	"./student_download_off.png": 635,
	"./test_off.png": 639,
	"./text_ch_off.png": 641,
	"./text_dictionary_off.png": 643,
	"./text_jp_off.png": 645,
	"./text_key_off.png": 647,
	"./upload_off.png": 264
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;



//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon ^\.\/.*_off\.png$
// module id = 817
// module chunks = 3